$(function()
{
	var fromRegistration = getUrlParam(window.location, 'registered');
	var toStep = getUrlParam(window.location, 'step');

	if (fromRegistration) {
		lendoutStepActionHandler($('.lendoutProgressActions .stepAction[data-current-step="2"][data-direction="down"]'))
	}
	if (toStep === "2" || toStep == "3" || toStep == "4") {
		lendoutStepActionHandler($('.lendoutProgressActions .stepAction[data-current-step="'+ toStep + '"][data-direction="down"]'));
	}
	setTimeout(function()
	{
		if($(el('edtEmailLendout')).length > 0 && $(el('edtEmailLendout')).val() !== "" && $(el('returningCustomerId')).val() !== "-1") {
			$(el('edtEmailLendout')).trigger('keyup');
		}
	} , 100);

	setDeliveryDate($(".lendoutProductsContainer input[name='inputRentStartingDate']"));

	// COLLAPSE
	$(el('mainContainer')).on('show','#deliveryLendoutAccordion >.accordion-group >.accordion-body', function(e)
	{
		if($(e.target).hasClass('accordion-body'))
		{
			$(this).parents('.accordion-group').addClass('activeAccordionGroup');
		}
	});

	$(el('mainContainer')).on('hide','#deliveryLendoutAccordion >.accordion-group >.accordion-body', function(e)
	{
		if($(e.target).hasClass('accordion-body'))
		{
			$('.accordion-group').removeClass('activeAccordionGroup');
		}
	});

	$(el('mainContainer')).on('click', '.lendoutProgressActions .cancelLendout', function(e)
	{
		e.preventDefault();
		$(el('lendoutFrm')).ajaxLoader('show')
		cancelLendoutOrder();
	});

	$(el('mainContainer')).on('click', '.lendoutProgressActions .stepAction', function(e)
	{
		e.preventDefault();

		lendoutStepActionHandler($(this));
	});

	$(el('mainContainer')).on('change','#inputPickupPoint', function()
	{
		// find selected option of this select
		var oSelectedOption = $(this).find('option:selected');
		var sPickupPointId = oSelectedOption.data('id');

		if(typeof sPickupPointId !== 'undefined' && sPickupPointId !== '')
		{
			if(typeof oSelectedOption.data('shopId') !== 'undefined' && oSelectedOption.data('shopId') !== '')
			{
				$(".toggleCustomerReceivedStockWrapper").show();
			}
			else
			{
				$(".toggleCustomerReceivedStockWrapper").hide();
			}

			var oCall = updateLendoutAddress('delivery');
			oCall.success(function(oData)
			{
				if (oData.errorType === "")
				{
					$(('.lendoutTotalsWrapper')).replaceWith(oData.lendoutTotals);
				}
				else
				{
					showAlert('error', oData.errorMessage, false);
				}
			});
		}
	});

	$(el('mainContainer')).on('click','#toggleIsExceptionalDateDelivery', function(e)
	{
		e.preventDefault();
		return false;
	});

	$(el('mainContainer')).on("click", ".lendoutProductsContainer #toggleMemberNumber", function (e) {
		var sLendoutId = $('#lendoutProductsContainer').data('lendoutid');
		var sParams = '&lendoutId=' + sLendoutId;
			sParams += '&member=' + $(this).is(':checked');
			$(el('lendoutFrm')).ajaxLoader('show')

		uAjax = "/index.cfm/product/ajax/updateLendoutInfo";
		var oCall = callAjax("updateLendoutInfo", sParams, "post");
		oCall.success(function(oData) {
			if (oData.errorType != '')
			{
				showAlert('error', oData.errorMessage, false);
				$(el('lendoutFrm')).ajaxLoader('hide')
			}
			else
			{
				handleUpdateLendout(oData);
			}
			$('.stepAction').prop('disabled', false)
		});
	});

	$(el('mainContainer')).on("click", ".lendoutProductsContainer #toggleDifficultDelivery", function (e) {
		var sLendoutId = $('#lendoutProductsContainer').data('lendoutid');
		var sParams = '&lendoutId=' + sLendoutId;
			sParams += '&difficultdelivery=' + $(this).is(':checked');
			$(el('lendoutFrm')).ajaxLoader('show')

		uAjax = "/index.cfm/product/ajax/updateLendoutInfo";
		var oCall = callAjax("updateLendoutInfo", sParams, "post");
		oCall.success(function(oData) {
			if (oData.errorType != '')
			{
				showAlert('error', oData.errorMessage, false);
				$(el('lendoutFrm')).ajaxLoader('hide')
			}
			else
			{
				handleUpdateLendout(oData);
			}
			$('.stepAction').prop('disabled', false)
		});
	});

	$(el('mainContainer')).on("keyup change", ".lendoutProductsTable .edtProductQty", function (e) {

		e.preventDefault();

		var sSkuId = $(this).closest('.product-row').data('skuid');
		var sLendoutId = $('#lendoutProductsContainer').data('lendoutid');
		var iQty = $(this).val();
		$('.stepAction').prop('disabled', true)
		updateLendout(sSkuId, sLendoutId, iQty, '')
	});

	$(el('mainContainer')).on("keyup change", ".lendoutProductsTable .edtConsumableQty", function (e) {

		e.preventDefault();

		var sSkuId = $(this).closest('.product-row').data('skuid');
		var iBasketLine = $(this).closest('.product-row').data('basketline');
		var sLendoutId = $('#lendoutProductsContainer').data('lendoutid');
		var iQty = $(this).val();
		$('.stepAction').prop('disabled', true)
		updateLendoutConsumables(sSkuId, sLendoutId, iQty, iBasketLine)
	});

	$(el('mainContainer')).on('keyup','#edtEmailLendout', function()
	{
		var bValidEmail = validateLendoutEmail();
		if(bValidEmail)
		{
			var oCall = checkEmail($(this).val());
			oCall.success(function(oData)
			{
				handleCheckEmail(oData);
			});
		}
	});

	$(el('mainContainer')).on('change', '#copyAddress', function(e)
	{
	var oCustomerForm = document.getElementById("frmCustomerAddress");
	var oDeliveryForm = document.getElementById("frmDeliveryAddress");
	if(e.target.checked) {
		copyForms(oCustomerForm , oDeliveryForm);
		$(".formAddressWrapper.delivery").addClass("hide");
	}
	else
	{
		$(".formAddressWrapper.delivery").removeClass("hide");
	}
	});

	$(el('mainContainer')).on('show','#deliveryLendoutAccordion >.accordion-group >.accordion-body', function(e)
	{
		if($(e.target).hasClass('accordion-body'))
		{
			var bUpdate =  false
			if($(this).data('collectmethodCode') === 'lendout_hd')
			{
				bUpdate = true;
			}
			else if($(this).data('collectmethodCode') === 'lendout_pickup')
			{
				var oSelectedOption = $('#inputPickupPoint option:selected');
				var sPickupPointId = oSelectedOption.data('id');
				if(typeof sPickupPointId !== 'undefined' && sPickupPointId !== '')
				{
					bUpdate = true;
				}
			}

			if(bUpdate)
			{
				var oCall = updateLendoutAddress('delivery');
				oCall.success(function(oData)
				{
					if (oData.errorType === "")
					{
						$(('.lendoutTotalsWrapper')).replaceWith(oData.lendoutTotals);
					}
					else
					{
						showAlert('error', oData.errorMessage, false);
					}
				});
			}
		}
	});
});

function handleUpdateLendout(oData)
{
	var htmlResult = $($.parseHTML(oData.html));
	$(('.lendoutProductsContainer .navItem')).each(function(){
		if(!$(this).hasClass("in")){
			htmlResult.find('#' + $(this).attr('id')).removeClass('in');
		}
	});
	$(('.lendoutProductsContainer')).replaceWith(htmlResult);
	setDeliveryDate($(".lendoutProductsContainer input[name='inputRentStartingDate']"),true);
	$(el('lendoutFrm')).ajaxLoader('hide');
	$('.lendoutQuantity').text(oData.lendoutQty);
	if (oData.lendoutQty > 0) {
		$('.lendoutQuantity').removeClass('hide');
	} else {
		$('.lendoutQuantity').addClass('hide');
	}
}

function lendoutStepActionProgress(iProgressStep)
{
	var oStep = $(".lendoutStep[data-step='" + iProgressStep + "']");
	var sTitle = oStep.data("title");

	$(".lendoutStep").hide();
	oStep.show();

	$(".lendoutProgressActions .stepAction").data("currentStep",iProgressStep);
	$(".lendoutProgress").find("h2").html(sTitle);
	$(".lendoutProgress").find('li').each(function()
	{
		$(this).removeClass("active");
		if(parseInt($(this).data("step")) <= iProgressStep)
		{
			$(this).addClass("active");
		}
	});
}

function finalizeLendoutOrder() {
	var sParams = '&lendoutId=' + $('#lendoutProductsContainer').data('lendoutid');
	uAjax = "/index.cfm/product/ajax/finalizeLendout";
	var oCall = callAjax("finalizeLendout", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType != '')
		{
			showAlert('error', oData.errorMessage, false);
			$(el('lendoutFrm')).ajaxLoader('hide')
		}
		else
		{
			window.location = oData.redirectURL;
		}
	});
}

function getLendoutProducts() {

	var sParams = '&customerId=' + $('#lendoutCustomerId').val();
	uAjax = "/index.cfm/product/ajax/lendoutProducts";
	var oCall = callAjax("lendoutProducts", sParams, "post");
	oCall.success(function(oData) {
		if (oData.lendoutProductsData.errorType != '')
		{
			showAlert('error', oData.lendoutProductsData.errorMessage, false);
			$(el('lendoutFrm')).ajaxLoader('hide')
		}
		else
		{
			handleUpdateLendout(oData);
		}
	});
}

function validateLendoutEmail()
{
	var oFrm       = $(el('frmLendout'));
	var bValidForm = validateForm(oFrm);

	setSubmitButtonStatus($(el('btnLendout')),bValidForm);

	if(!bValidForm && !fieldIsValid($(el('edtEmailLendout'))))
	{
		setReturningCustomer(false);
	}

	return bValidForm;
}

function setSubmitButtonStatus(oBtn,bStatus)
{
	if(bStatus)
	{
		oBtn.removeClass('frmInvalid').addClass('frmValid');
	}
	else
	{
		oBtn.removeClass('frmValid').addClass('frmInvalid');

		setSubmitDisabled(bStatus);
	}
}

function setSubmitDisabled(bEnable)
{
	$('.LendoutSubmitButton').prop('disabled',bEnable).removeClass('disabledtrue disabledfalse').addClass('disabled'+bEnable);

	// disable accordion
	if(bEnable)
	{
		$('.accordion-heading .accordion-toggle').addClass('disableToggle');
	}
	else
	{
		$('.accordion-heading .accordion-toggle').removeClass('disableToggle');
	}
}

function setReturningCustomer(bExists)
{
	if(bExists)
	{
		$('.returningCustomer,.btnLendoutWrapperNoLogin').show();
		$(el('btnLendout')).text(sLendoutBtnAndLogin);
	}
	else
	{
		$('.returningCustomer,.btnLendoutWrapperNoLogin').hide();
	}
}

function handleCheckEmail(oData)
{
	$(".identifyWrapper").removeClass("blockedCustomer");
	if(oData.errorType === 'exists')
	{
		if(oData.data.id !== 'undefined')
		{
			if ($(el('returningCustomerId')).val() == '-1') {
				$(el('returningCustomerId')).val(oData.data.id);
			}
		}
		setReturningCustomer(true);
	}
	else if(oData.errorType === "")
	{
		if ($(el('returningCustomerId')).val() !== '-1') {
			setReturningCustomer(true);
		}
		else
		{
			setReturningCustomer(false);
		}
	}
	else
	{
		$(el('returningCustomerId')).val("-1");
		setReturningCustomer(false);
	}
}

function checkEmail(sEmail)
{
	uAjax = '/index.cfm/customer/ajax/checkemail';

	var sParams = '&email=' + encodeURIComponent(sEmail);
	return oCall   = callAjax("checkemail", sParams, "post");
}

function updateLendoutAddress(sType)
{
	var oFrm     = (sType === "customer") ? document.getElementById("frmCustomerAddress"): document.getElementById("frmDeliveryAddress");
	var oFrmData = new FormData(oFrm);
	var oAddress = Object.fromEntries(oFrmData);

	var sParams = '&lendoutId=' + sLendoutId + '&address=' + oAddress['inputStreetName'] + '&city=' + oAddress['inputCity'] + '&country=' + oAddress['inputCountry'] + '&firstName=' + oAddress['inputFirstName'] + '&lastName=' + oAddress['inputLastName'] + '&houseNumber=' + oAddress['inputHousenumber'] + '&postalCode=' + oAddress['inputPostalCode'] + '&box=' + oAddress['inputBox'] + '&deliverydate=' + oAddress['deliveryDate'] + '&type=' + sType;

	if(sType === "customer")
	{
		sParams += '&email=' + encodeURIComponent(oAddress['inputEmail']) + '&languageCode=' + oAddress['inputlanguageCode'] + '&id=' + oAddress['inputid'] + '&phonenumber=' + oAddress['inputPhoneNumber'] + '&mobileNumber=' + oAddress['inputMobileNumber'] + '&extraemail=' + oAddress['inputExtraEmail'] + '&identity=' + oAddress['inputIdentityCard'] ;
	}
	else
	{
		oAddress.collectMethod = $('#deliveryLendoutAccordion .activeAccordionGroup .accordion-toggle').data('collectmethod');

		if ($('#inputPickupPoint option:selected').length != 0)
		{
			oAddress.pickupPoint = $('#inputPickupPoint option:selected').data('id');

			if($("#toggleCustomerReceivedStock").is(':checked') && typeof $('#inputPickupPoint option:selected').data('shopId') !== 'undefined')
			{
				sParams += "&customerReceivedStockFrom=" + $('#inputPickupPoint option:selected').data('shopId');
			}
		}
		else
		{
			oAddress.pickupPoint = '';
			sParams += "&customerReceivedStockFrom=-1";
		}

		sParams += '&collectmethod=' + oAddress['collectMethod'] + '&pickupid=' + oAddress['pickupPoint'];

		if($("#toggleIsExceptionalDateDelivery").length > 0)
		{
			sParams += "&isExceptionalDate=" + $("#toggleIsExceptionalDateDelivery").is(':checked');
		}
	}

	uAjax = "/index.cfm/product/ajax/updateLendoutAddress";
	return callAjax("updateLendoutAddress", sParams, "post");
}

function updateLendout(sSkuId, sLendoutId, iQty, sStartDate, bIsExceptionalDate) {

	var sParams = '&lendoutId=' + sLendoutId;
	if (sStartDate != '')
	{
		sParams += '&startDate=' + sStartDate + "&isExceptionalDate=" + bIsExceptionalDate;
	} else {
		sParams += '&skuId=' + sSkuId + '&qty=' + iQty;
	}
	uAjax = "/index.cfm/product/ajax/updateLendoutProduct";
	var oCall = callAjax("updateLendoutProduct", sParams, "post");
	oCall.success(function(oData) {
		if(oData.errorType === 'lendingOrderNotInDraft' )
		{
			window.location.reload();
		}
		else if (oData.errorType != '')
		{
			showAlert('error', oData.errorMessage, false);
			$(el('lendoutFrm')).ajaxLoader('hide')
		}
		else
		{
			handleUpdateLendout(oData);
		}
		$('.stepAction').prop('disabled', false)
	});
}

function updateLendoutDeliveryDate(sDeliveryDate, bIsExceptionalDate)
{
	var sParams = '&deliveryDate=' + sDeliveryDate + "&isExceptionalDate=" + bIsExceptionalDate;

	var oCall = callAjax("updateLendoutDeliveryDate", sParams, "post", "/index.cfm/product/ajax/updateLendoutDeliveryDate");
	oCall.success(function(oData) {
		if (oData.errorType != '')
		{
			showAlert('error', oData.errorMessage, false);

		}
		else
		{
			$(('.lendoutTotalsWrapper')).replaceWith(oData.lendoutTotals);
		}

		$(el('lendoutFrm')).ajaxLoader('hide');
		$('.stepAction').prop('disabled', false)
	});
}

function updateLendoutConsumables(sSkuId, sLendoutId, iQty, iBasketLine) {

	var sParams = '&lendoutId=' + sLendoutId;
		sParams += '&skuId=' + sSkuId + '&qty=' + iQty + '&ibasketline=' + iBasketLine;
	uAjax = "/index.cfm/product/ajax/updateConsumableLendout";
	var oCall = callAjax("updateConsumableLendout", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType === '' || oData.ErrorType === '')
		{
			getLendoutProducts();
		}
		else
		{
			showAlert('error', oData.errorMessage, false);
		}
		$('.stepAction').prop('disabled', false)
	});
}

function cancelLendoutOrder() {
	const sLendoutId = $('#lendoutProductsContainer').data('lendoutid');
	var sParams = '&lendoutId=' + sLendoutId;

	uAjax = "/index.cfm/product/ajax/cancelLendoutOrder";
	var oCall = callAjax("cancelLendoutOrder", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType != '')
		{
			$(el('lendoutFrm')).ajaxLoader('hide')
			showAlert('error', oData.errorMessage, false);
		}
		else
		{
			window.location = '/' + sCurrentLanguageCode;
		}
	});
}

function lendoutStepActionHandler(oBtn)
{
	var iCurrentLendoutStep = parseInt(oBtn.attr( "data-current-step" ));
	var sDirection          = oBtn.attr("data-direction");
	var returningCustomer   = $(el('returningCustomerId')).val();

	if((iCurrentLendoutStep == 2 && sDirection == "up") || (iCurrentLendoutStep == 3 && sDirection == "up") )
	{
		lendoutStepActionProgress(1);
	}
	else if (iCurrentLendoutStep == 2 && sDirection == "down")
	{
		$(el('lendoutFrm')).ajaxLoader('show');
		executeIdentify();
	}
	else if((iCurrentLendoutStep == 3 && sDirection == "down"))
	{
		$(el('lendoutFrm')).ajaxLoader('show')

		var bValid = validateForm($("#frmCustomerAddress"));

		if (bValid)
		{
			iCurrentLendoutStep = (sDirection == "down") ? iCurrentLendoutStep+1 : iCurrentLendoutStep-1;
			$('.initialInvoiceCost').text($('.initialInvoice.totals').text());

			$( "#totalPricesDeliverypage").html('');
			$( ".lendoutTotalsWrapper" ).clone().appendTo( "#totalPricesDeliverypage" );
			var oCall = updateLendoutAddress('customer');
			oCall.success(function(oData)
			{
				if (oData.errorType !== "")
				{
					showAlert('error', oData.errorMessage, false);
					$(el('lendoutFrm')).ajaxLoader('hide')
				}
				else
				{
					$(('.formAddressWrapper.customer')).replaceWith(oData.lendoutCustomerAddress);
					lendoutStepActionProgress(iCurrentLendoutStep);
					$(el('lendoutFrm')).ajaxLoader('hide');
				}
			});

			if ($('#frmDeliveryAddress #copyAddress').is(':checked')) {
				var oCustomerForm = document.getElementById("frmCustomerAddress");
				var oDeliveryForm = document.getElementById("frmDeliveryAddress");
				copyForms(oCustomerForm , oDeliveryForm);
			}
		}
		else
		{
			$(el('lendoutFrm')).ajaxLoader('hide');
		}
	}
	else if((iCurrentLendoutStep == 3 && sDirection == "up"))
	{
			if (returningCustomer !== "-1") {

				lendoutStepActionProgress(1);
			}
			$(el('lendoutFrm')).ajaxLoader('hide')
	}
	else if((iCurrentLendoutStep == 4 && sDirection == "down")) // Submit delivery address/method
	{
		$(el('lendoutFrm')).ajaxLoader('show');

		var bValid = validateForm($("#frmDeliveryAddress"));
		if (bValid)
		{
			var oCall = updateLendoutAddress('delivery');
			oCall.success(function(oData)
			{
				if (oData.errorType !== "")
				{
					showAlert('error', oData.errorMessage, false);
					$(el('lendoutFrm')).ajaxLoader('hide')
				}
				else
				{
					finalizeLendoutOrder();
				}
			});
		}
		else
		{
			$(el('lendoutFrm')).ajaxLoader('hide');
		}
	} else
	{
		iCurrentLendoutStep = (sDirection == "down") ? iCurrentLendoutStep+1 : iCurrentLendoutStep-1;
		lendoutStepActionProgress(iCurrentLendoutStep);
	}
}

function copyForms( $form1 , $form2 ) {
	$(':input[name]', $form2).val(function() {
		if(this.name == 'deliveryDate') {
			return $(':input[name=' + this.name + ']', $form2).val();
		} else {
			return $(':input[name=' + this.name + ']', $form1).val();
		}
	});
}

function executeIdentify(token){

	var oCall = checkEmail($(el('edtEmailLendout')).val());
	oCall.success(function(oData)
	{
		handleCheckEmail(oData);

		var bReturningCustomer = (typeof $(el('returningCustomerId')).val() !== "undefined" && $(el('returningCustomerId')).val() !== "-1") ? true: false;
		submitIdentification(bReturningCustomer, token);
	});
}

function submitIdentification(bReturningCustomer,token)
{

	var bValidEmail = validateLendoutEmail();

	if(bValidEmail)
	{
		uAjax = "/index.cfm/product/ajax/identify";
		var bRememberLogin = $(el('toggleRememberLogin')).is(':checked');
		var sCustomerId    = $(el('returningCustomerId')).val();
		var sEmail         = encodeURIComponent($(el('edtEmailLendout')).val());
		const sLendoutId = $('#lendoutProductsContainer').data('lendoutid');
		var sPassword      = encodeURIComponent($(el('edtPasswordLendout')).val());
		var sToken		   = encodeURIComponent(token);
		var sParams        = '&edtEmail=' + sEmail + '&password=' + sPassword + '&remember=' + bRememberLogin + '&returningCustomer=' + bReturningCustomer + '&customerId=' + sCustomerId + '&grecaptchatoken=' + token + '&lendoutId=' + sLendoutId;;
		var oCall          = callAjax("identify", sParams, "post");
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				if (typeof oData.redirectURL !== "undefined") {
					window.location = oData.redirectURL;
				} else {
					$(('.formAddressWrapper.customer')).replaceWith(oData.lendoutCustomerAddress);
					$(('#deliveryAccordion')).replaceWith(oData.lendoutDeliveryAddress);
					setDeliveryDate($("#deliveryAccordion input[name='deliveryDate']"));
					$(el('returningCustomerId')).val(oData.customerId);
					lendoutStepActionProgress(3);
					$(el('lendoutFrm')).ajaxLoader('hide');
				}
			}
			else if (oData.errorMessage === 'blocked')
			{
				$(".identifyWrapper").addClass("blockedCustomer");

				showAlert('error', oData.errorMessage, false);
				$(el('lendoutFrm')).ajaxLoader('hide');
			}
			else if(oData.errorType === 'multiple')
			{
				clearErrors();

				$(el("contactsPopup")).remove();
				$(el("mainContainer")).append(oData.html);
				$(el("contactsPopup")).modal();

				centerPopups();
				$(el('lendoutFrm')).ajaxLoader('hide');
			}
			else
			{
				showAlert('error', oData.errorMessage, false);
				$(el('lendoutFrm')).ajaxLoader('hide');
			}
		});
	} else {
		$(el('lendoutFrm')).ajaxLoader('hide');
	}
}

function isPastDate(oDate)
{
	var oNow     = new Date();
	var iMinDate = (typeof sMinDate !== 'undefined' && sMinDate !== "") ? parseInt(sMinDate) : 2;
	var oMinDate = oNow.setDate(oNow.getDate()+iMinDate);

	return (oDate < oMinDate)
}

function setMindateObject() {
	var minDate = (typeof sMinDate !== 'undefined' && sMinDate !== "") ? parseInt(sMinDate) : 2;
	// Check to add extra days
	if (typeof addDays !== "undefined" && parseFloat(addDays) > 0) {
		minDate += parseFloat(addDays);
	};

	var bResetDate = false;

	// Prevent next day delivery select after 15h
	var oDeliveryDate = new Date();
	if(minDate == 1 && oDeliveryDate.getHours() >= iNextDayDeliveryCutOff)
	{
		bResetDate = true;
		minDate++;
		oDeliveryDate.setDate(oDeliveryDate.getDate() + minDate);

		var bNextDatePlusOneIsEnabled = checkDisableDays(oDeliveryDate,minDate)[0];
		var foundEnabledDate = false;
		while (!foundEnabledDate)
		{
			if(checkDisableDays(oDeliveryDate,minDate)[0])
			{
				foundEnabledDate = true;

				if(!bNextDatePlusOneIsEnabled)
				{
					minDate += 1;
				}
			}
			else
			{
				minDate++;
				oDeliveryDate.setDate(oDeliveryDate.getDate() + minDate);
			}
		}
	}
	else if(minDate == 1 && oDeliveryDate.getHours() < iNextDayDeliveryCutOff)
	{
		// excluded dates are not allowed to have next day delivery
		var isExcludedDate = sExcludeDatepickerDays.toString().split(',').includes(formatExcludeDatepickerDays(oDeliveryDate));
		if(isExcludedDate)
		{
			minDate++;
		}
	}

	return { minDate: minDate, bResetDate: bResetDate } ;
}

function formatExcludeDatepickerDays(date) {
	let day   = date.getDate();
	let month = date.getMonth() + 1;

	return (day < 10 ? '0' : '') + day + (month < 10 ? '0' : '') + month;
}

function setDeliveryDate(oEl,bPreventReset)
{
	var minDateObject = setMindateObject();

	oEl.datepicker(
		{
			dateFormat: "dd/mm/yy",
			minDate: (bUserIsAgent)? 0 : minDateObject.minDate,
			beforeShowDay: checkDisableDays,
			onSelect: function(date,oEl)
			{
				var sDay = oEl.selectedDay,
					sMon = oEl.selectedMonth,
					sYear = oEl.selectedYear;

				var oSelectedDate = $(oEl.dpDiv).find('[data-year="'+sYear+'"][data-month="'+sMon+'"]').filter(function() {
					return $(this).find('a').text().trim() == sDay;
				});

				if($(this).hasClass("deliveryDate"))
				{
					$(el('lendoutFrm')).ajaxLoader('show')
					var sDeliveryDate = $(this).val();

					updateLendoutDeliveryDate(sDeliveryDate, $(oSelectedDate).hasClass("disabledDateOnlyForAgents"));

					if($(oSelectedDate).hasClass("disabledDateOnlyForAgents"))
					{
						$(".toggleIsExceptionalDateLabel").show();
					}
					else
					{
						$(".toggleIsExceptionalDateLabel").hide();
					}
				}
			}
		}
	);

	if(typeof bPreventReset === 'undefined' && (oEl.datepicker('getDate') === null || isPastDate(oEl.datepicker('getDate')) || minDateObject.bResetDate))
	{
		setDefaultDeliveryDate(oEl,minDateObject.minDate);
	}
}

function setDefaultDeliveryDate(oEl,minDate)
{
	var oDeliveryDate = new Date();

	if(typeof minDate !== 'undefined')
	{
		oDeliveryDate.setDate(oDeliveryDate.getDate() + minDate);

		// check if default is disabled - +1 if default is disabled
		var foundEnabledDate = false;
		while (!foundEnabledDate)
		{
			if(checkDisableDays(oDeliveryDate)[0])
			{
				foundEnabledDate = true;
			}
			else
			{
				oDeliveryDate.setDate(oDeliveryDate.getDate() + 1);
			}
		}
	}

	var aList = [];
	if(typeof sDisableSpecificDays !== 'undefined' && sDisableSpecificDays !== '')
	{
		var daysList = sDisableSpecificDays.toString().split(',');
		daysList = daysList.map(String);
		aList = daysList;
	}

	if(aList.length > 0)
	{
		if(aList.find(function(listDate){return oDeliveryDate.getDay().toString() == listDate}))
		{
			var matchedDate = false;
			while (!matchedDate)
			{
				oDeliveryDate.setDate(oDeliveryDate.getDate() + 1);
				if(typeof aList.find(function(listDate){return oDeliveryDate.getDay().toString() == listDate}) == 'undefined')
				{
					matchedDate = true;
				}
			}
		}
		if(oEl.attr('type') == 'hidden')
		{
			oEl.val(oDeliveryDate.getDate() + '-' + (oDeliveryDate.getMonth() + 1) + '-' + oDeliveryDate.getFullYear());
		}
		else
		{
			oEl.datepicker('setDate', oDeliveryDate);
		}
	}
}

function checkDisableDays(date, minDate)
{
	var aList = [];
	if(typeof sDisableSpecificDays !== 'undefined' && sDisableSpecificDays !== '')
	{
		var daysList = sDisableSpecificDays.toString().split(',');
		daysList = daysList.map(String);
		aList = daysList;
	}

	var filterDay = date.getDate().toString() + '/' + date.getMonth().toString();

	var aExcludedDates = [];
	if (!sExcludeDatepickerDays) {
		sExcludeDatepickerDays = "2512,0101";
	}

	// Format to JS dates
	sExcludeDatepickerDays.toString().split(",").forEach(function(date){
		var newDate = parseInt(date.substr(0, 2)).toString() + "/" + (parseInt(date.substr(2)) - 1).toString();
		aExcludedDates.push(newDate);
	});

	var currentDate = new Date();
	currentDate.setHours(0, 0, 0, 0);
	var minDateObj = new Date();

	var iMinDate = (typeof minDate !== 'undefined' && minDate !== "") ? parseInt(minDate) : setMindateObject().minDate;

	minDateObj.setDate(currentDate.getDate() + (iMinDate-1));
	if (bUserIsAgent && date >= currentDate && date < minDateObj)
	{
		return [true, "disabledDateOnlyForAgents",""];
	}
	else
	{
		if ($.inArray(filterDay, aExcludedDates) > -1)
		{
			if(bUserIsAgent)
			{
				return [true,"disabledDateOnlyForAgents",""];
			}
			else
			{
				return [false];
			}
		}

		if(aList.find(function(listDate){
			return date.getDay().toString() == listDate
		}))
		{
			if(bUserIsAgent)
			{
				return [ true,"disabledDateOnlyForAgents",""];
			}
			else
			{
				return [ false,"",""];
			}
		}
		else
		{
			return [ true, "", ""];
		}
		var beforeShowDay = (bDisableWeekends) ? $.datepicker.noWeekends : null;
	}
}